import type { DidDisconnectAuthStatusDatagramBuf } from "~/classes/generated/status"

import { parseAnonymousIdBuf as parseAnonymousId } from "~/utils/flatbuffers/anonymous"
import { parseUserId } from "~/utils/flatbuffers/id"

const console = useLogger("status/disconnect-auth")

export function handleDidDisconnectAuthStatusDatagramBuf(buf: DidDisconnectAuthStatusDatagramBuf) {
  const { emitInterfaceEvent } = useEvents()
  const { cacheState } = useCache()
  const { logOut } = useAuthentication()

  const datagram: DidDisconnectAuthStatusDatagram = {
    userId: parseUserId(buf.userId()!),
    isTokenInvalid: buf.isTokenInvalid(),
    newAnonId: parseAnonymousId(buf.newAnonId()!),
  }
  console.info("Disconnected authenticated cache connection")
  cacheState.value.status = "offlineAnon"
  cacheState.value.userId = undefined
  cacheState.value.anonId = datagram.newAnonId
  cacheState.value.nextReconnectDate = undefined

  // NOTE: In instances where the access token in missing, this log out is redundant, but
  // it navigates us to the login, etc, so it doesn't hurt.
  if (datagram.isTokenInvalid)
    logOut()

  emitInterfaceEvent("didDisconnectAuthStatus", datagram)
}
